
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "Login",
  components: {}
})
export default class extends Vue {
  $refs!: {
    form: HTMLFormElement;
  };
  private valid = false;
  private loading = false;
  private show1 = false;

  private loginForm = {
    username: "",
    password: ""
  };

  private usernameRules = [
    (v: string) => !!v || "نام کاربری الزامی میباشد",
    (v: string) => /^(09|9)+([0-9]){9}$/.test(v) || "شماره موبایل اشتباه است"
  ];
  private passwordRules = [
    (v: string) => !!v || "رمز عبور   الزامی میباشد",
    (v: string) => v.length > 7 || "رمز عبور   باید هشت رقم باشد "
  ];

  private async handleLogin() {
    this.validationForm();
    if (!this.valid) return;

    this.loading = true;
    try {
      await UserModule.Login(this.loginForm);
      await UserModule.GetCode(this.loginForm.username);

      this.loading = false;
      this.$router.push("/verify-code");
    } catch (error) {
      this.loading = false;
    }
  }
  private validationForm() {
    this.$refs.form.validate();
  }
}
